import { httpClient } from "../../shared/configs/http-client";
import {
  ArticleDetails,
  CreateArticlePayload,
  GetArticlesPayload,
  GetArticlesResponse,
} from "./types";

const getList = async (params: GetArticlesPayload) => {
  const { data } = await httpClient.get<GetArticlesResponse>("/articles/list", {
    params,
  });

  return data;
};

const getById = async (id: string) => {
  const { data } = await httpClient.get<ArticleDetails>(`/articles/${id}`);

  return data;
};

export const downloadScreenshots = async (id: string) => {
  try {
    const response = await httpClient.get<Blob>(`/articles/${id}/screenshots`, {
      responseType: "blob",
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `screenshots.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Failed to download screenshots", error);
  }
};

export const createArticles = (payload: CreateArticlePayload) => {
  const articles = payload.articles?.map((article) => ({
    ...article,
    date: article.date ? new Date(article.date).toISOString() : undefined,
  }));

  return httpClient.post("/articles/analyze", {
    ...payload,
    articles,
  });
};

const deleteById = async (id: string) => {
  const { data } = await httpClient.delete<{ id: string; campaignId: string }>(
    `/articles/${id}`
  );

  return data;
};

const deleteSimilarArticleById = async (id: string) => {
  const { data } = await httpClient.delete<{ id: string; articleId: string }>(
    `/articles/similar/${id}`
  );

  return data;
};

export const articlesApi = {
  getList,
  getById,
  downloadScreenshots,
  createArticles,
  deleteById,
  deleteSimilarArticleById,
};
